import React from "react";

import { LoginFormContainer } from "../Form/LoginForm";
import Modal from "../Modal";
import { useModal } from "../../context/ModalContext";

const LoginModal: React.FC = () => {
  const {
    isLoginOpen,
    closeLoginModal,
    openSignupModal,
    openForgotPasswordModal,
  } = useModal();
  const handleSubmit = (email: string, password: string) => {
    console.log("Login attempt", { email, password });
  };

  return (
    <Modal
      isOpen={isLoginOpen}
      onClose={closeLoginModal}
      className="w-[90%] md:w-[400px]"
    >
      <LoginFormContainer
        closeLoginModal={closeLoginModal}
        onForgotPassword={() => {
          closeLoginModal();
          openForgotPasswordModal();
        }}
        onSignUp={() => {
          closeLoginModal();
          openSignupModal();
        }}
        onSubmit={handleSubmit}
      />
    </Modal>
  );
};

export default LoginModal;
